/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Field_Tax_Country_RequiredInputs */



/**
* | output |
* | --- |
* | "Tax country (required)" |
*
* @param {Partner_Admin_Field_Tax_Country_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_field_tax_country_required = /** @type {((inputs?: Partner_Admin_Field_Tax_Country_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Field_Tax_Country_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Steuerland (erforderlich)")
	return /** @type {LocalizedString} */ ("Tax country (required)")
});